

































































































































import Toolbar from '@/components/Toolbar.vue';
import { State } from '@/store/State';
import { Client, ClientSurveyInfo } from '@holistic/shared/src/domain/Client';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    Toolbar,
  },
})
export default class Clients extends Vue {
  public $refs!: {
    addClientForm: HTMLFormElement;
    addSurveyForm: HTMLFormElement;
  };
  private displayAddClientDialog = false;
  private newClient = '';
  private loading = true;
  private clientToAddSurveysTo: Client | null = null;
  private showAddSurveysModal = false;
  private selectedTemplateId: string | null = null;
  private clientNameRules = [
    (name: string) => !!name || 'Name Required',
    (name: string) =>
      this.uniqueClientName(name) || 'Duplicate clients not allowed',
  ];
  private addSurveyRules = [
    (templateId: string | null) => !!templateId || 'Survey Required',
  ];

  @Prop(Boolean) private readonly featureFlagClientInvite!: boolean;

  private async created() {
    await this.$store.dispatch('bindClients');
    await this.$store.dispatch('bindSurveyTemplates');
    this.loading = false;
  }

  private destroyed() {
    this.$store.dispatch('unbindClients');
    this.$store.dispatch('unbindSurveyTemplates');
  }

  private get clients() {
    return (this.$store.state as State).clients;
  }

  private get surveyTemplates() {
    return (this.$store.state as State).surveyTemplates;
  }

  private get showEmptyMessage() {
    return !this.loading && this.clients.length === 0;
  }

  private addClient() {
    if (!this.$refs.addClientForm.validate()) {
      return;
    }
    this.$store.dispatch('addClient', { clientName: this.newClient });
    this.displayAddClientDialog = false;
    this.newClient = '';
    this.$refs.addClientForm.resetValidation();
  }

  private async addSurvey() {
    if (!this.$refs.addSurveyForm.validate()) {
      return;
    }
    await this.$store.dispatch('addSurvey', {
      clientId: this.clientToAddSurveysTo!.id,
      templateId: this.selectedTemplateId!,
    });
    this.showAddSurveysModal = false; 
    this.$refs.addSurveyForm.resetValidation();
  }

  private surveyLink(surveyInfo: ClientSurveyInfo) {
    return `/surveys/${this.refToId(surveyInfo.ref)}`;
  }

  private inviteLink(client: Client) {
    return `/clients/${this.refToId(client.id)}/invite`;
  }

  private refToId(ref: string) {
    return ref.substring(ref.lastIndexOf('/') + 1);
  }

  private showAddSurveysToClientDialog(client: Client) {
    this.clientToAddSurveysTo = client;
    this.showAddSurveysModal = true;
  }

  private get unaddedSurveys() {
    if (!this.clientToAddSurveysTo) {
      return this.surveyTemplates;
    }

    const clientSurveyNames = this.clientToAddSurveysTo.surveys.map(
      (surveyInfo) => {
        return surveyInfo.name;
      },
    );
    return this.surveyTemplates.filter((template) => {
      return !clientSurveyNames.includes(template.name);
    });
  }

  private showAddClientDialog() {
    this.displayAddClientDialog = true;
  }

  private uniqueClientName(name: string) {
    return !(this.$store.state as State).clients
      .map((c) => c.name)
      .includes(name);
  }
}
